import React from 'react';

import { StyledSection, StyledSectionInner, StyledMessage, StyledSpinner } from './styles';

const Loading = () => {
  return (
    <StyledSection>
      <StyledSectionInner>
        <StyledMessage>
          Give us a second while we find some relevant articles.
        </StyledMessage>
        <StyledSpinner />
      </StyledSectionInner>
    </StyledSection>
  );
};

export default Loading;
